import { useState } from 'react';
import { sound } from '../lib/sound';
import { useStrings } from '../state/useLocale';

/**
 * Sound carries the feedback that colour normally would in this interface, so
 * the control for it is always reachable rather than buried in a settings page.
 */
export function MuteToggle() {
  // From the catalogue, like everything else the interface says. These four
  // sentences have been written in both languages since the translation
  // landed (lib/strings/app.ts, `sound`); this component was the one place
  // still printing the English ones at an Arabic reader.
  const s = useStrings().app.sound;
  const [muted, setMuted] = useState(sound.muted);
  return (
    <button
      className="mute"
      type="button"
      aria-pressed={muted}
      title={muted ? s.titleMuted : s.titleOn}
      aria-label={muted ? s.labelMuted : s.labelOn}
      onClick={() => {
        const next = !muted;
        sound.setMuted(next);
        setMuted(next);
        if (!next) sound.click();
      }}
    >
      <svg viewBox="0 0 16 16" aria-hidden="true" width="14" height="14">
        <path d="M3 6h2.5L9 3v10L5.5 10H3z" fill="currentColor" />
        {muted ? (
          <path d="M11 6l4 4M15 6l-4 4" stroke="currentColor" strokeWidth="1.4" fill="none" strokeLinecap="round" />
        ) : (
          <>
            <path d="M11.4 5.6a3.4 3.4 0 0 1 0 4.8" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round" />
            <path d="M13.4 3.6a6.2 6.2 0 0 1 0 8.8" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round" opacity="0.55" />
          </>
        )}
      </svg>
    </button>
  );
}
